import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function PaymentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const paymentLink = location.state?.paymentLink || sessionStorage.getItem("subscriptionPaymentLink");
  const summary = location.state?.summary || JSON.parse(sessionStorage.getItem("subscriptionSummary") || "null");

  if (!paymentLink) {
    return (
      <main className="page" dir="rtl">
        <section className="panel">
          <img src="/logo.png" alt="Blue Parking" className="logo" />
          <h1>לא נמצא תשלום פעיל</h1>
          <button onClick={() => navigate("/")}>חזרה להתחלה</button>
        </section>
      </main>
    );
  }

  return (
    <main className="page payment-page" dir="rtl">
      <section className="payment-shell">
        <div className="payment-header">
          <button type="button" className="secondary" onClick={() => navigate("/")}>חזרה</button>
          <img src="/logo.png" alt="Blue Parking" className="payment-logo" />
          <div>
            <strong>{summary?.carId}</strong>
            {summary?.phoneNumber || summary?.userId ? (
              <span>{summary.phoneNumber || summary.userId}</span>
            ) : null}
            <span>{summary?.placeName} | {summary?.amount} ₪</span>
          </div>
        </div>
        <iframe
          allowPaymentRequest="true"
          title="PayPlus"
          src={paymentLink}
          className="payment-frame"
        />
      </section>
    </main>
  );
}
